export const emptyForm = {
  name: "", category: "Kitchenware", description: "", sku: "", material: "", size: "", dimensions: "",
  variantsText: "", brandsText: "", specs: [], stock_quantity: "0", low_stock_threshold: "5", contactUs: false,
  is_published: true, cost_price: "", selling_price: "",
};

export function toForm(p) {
  if (!p) return { ...emptyForm };
  return {
    name: p.name, category: p.category, description: p.description || "", sku: p.sku || "", material: p.material || "",
    size: p.size || "", dimensions: p.dimensions || "", variantsText: (p.variants || []).join(", "), brandsText: (p.brands || []).join(", "),
    specs: Object.entries(p.specifications || {}).map(([k, v]) => ({ k, v })),
    stock_quantity: String(p.stock_quantity ?? 0), low_stock_threshold: String(p.low_stock_threshold ?? 5),
    contactUs: p.availability_status === "Contact Us", is_published: !!p.is_published,
    cost_price: p.cost_price ?? "", selling_price: p.selling_price ?? "",
  };
}

const num = (v) => (v === "" || v === null || v === undefined ? null : Number(v));

export function toPayload(f) {
  return {
    name: f.name.trim(), category: f.category, description: f.description, sku: f.sku.trim() || null,
    material: f.material, size: f.size, dimensions: f.dimensions,
    variants: f.variantsText.split(",").map((s) => s.trim()).filter(Boolean),
    brands: f.brandsText.split(",").map((s) => s.trim()).filter(Boolean),
    specifications: Object.fromEntries(f.specs.filter((s) => s.k.trim()).map((s) => [s.k.trim(), s.v])),
    stock_quantity: Number(f.stock_quantity), low_stock_threshold: Number(f.low_stock_threshold),
    availability_status: f.contactUs ? "Contact Us" : null, is_published: f.is_published,
    cost_price: num(f.cost_price), selling_price: num(f.selling_price),
  };
}

export function validate(f) {
  if (f.name.trim().length < 2) return "Product name must be at least 2 characters";
  const q = Number(f.stock_quantity);
  if (!Number.isInteger(q) || q < 0) return "Stock must be a whole number, 0 or more";
  const t = Number(f.low_stock_threshold);
  if (!Number.isInteger(t) || t < 0) return "Low-stock alert must be a whole number";
  for (const k of ["cost_price", "selling_price"]) {
    if (f[k] !== "" && (Number.isNaN(Number(f[k])) || Number(f[k]) < 0)) return "Prices must be positive numbers";
  }
  return null;
}

export function previewStatus(f) {
  if (f.contactUs) return "Contact Us";
  const q = Number(f.stock_quantity) || 0;
  if (q <= 0) return "Out of Stock";
  return q <= (Number(f.low_stock_threshold) || 0) ? "Low Stock" : "In Stock";
}
